import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <p className="text-sm text-gray-600 mb-8">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the services of Colorado First Plumbing & Sewer LLC ("Company," "we," "our," or "us"), 
                you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, 
                please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Services Provided</h2>
              <p>We provide professional plumbing services including but not limited to:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Emergency plumbing repairs</li>
                <li>Water heater installation and repair</li>
                <li>Sewer line services and repairs</li>
                <li>Bathroom and kitchen remodeling</li>
                <li>Commercial plumbing services</li>
                <li>Drain cleaning and maintenance</li>
                              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Service Agreements</h2>
              <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Estimates and Pricing</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>All estimates are provided free of charge and are valid for 30 days</li>
                <li>Pricing is transparent and available on our website</li>
                <li>Final pricing may vary based on actual conditions discovered during service</li>
                <li>Emergency services may include additional surcharges</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Service Scheduling</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service appointments are scheduled subject to technician availability</li>
                <li>We strive to arrive within the scheduled time window</li>
                <li>Customer must provide access to work areas</li>
                <li>Cancellations must be made at least 24 hours in advance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Payment Terms</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Payment is due upon completion of services unless other arrangements are made</li>
                <li>We accept cash, check, and major credit cards</li>
                <li>Financing options may be available for qualifying customers</li>
                <li>Late payments may incur additional fees</li>
                <li>Collections costs may be charged for delinquent accounts</li>
              </ul>
            </section>

            <section>
                                                        <ul className="list-disc pl-6 space-y-2 mt-3">
                                                                              </ul>

                            <ul className="list-disc pl-6 space-y-2">
                                                                <li>Acts of God or natural disasters are not covered</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Colorado First Plumbing & Sewer LLC shall not be liable 
                for any indirect, incidental, special, consequential, or punitive damages, including but not limited 
                to loss of profits, data, or use, regardless of whether we have been advised of the possibility 
                of such damages.
              </p>
              <p className="mt-3">
                Our total liability for any claim shall not exceed the amount paid for the specific service giving rise to the claim.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Customer Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information about plumbing issues</li>
                <li>Ensure safe access to work areas</li>
                <li>Disclose all relevant information about the property and plumbing system</li>
                <li>Be present or designate an authorized representative during service</li>
                <li>Make timely payments for services rendered</li>
                <li>Follow all care and maintenance instructions provided</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Intellectual Property</h2>
              <p>
                All content on our website, including text, graphics, logos, and software, is the property of 
                Colorado First Plumbing & Sewer LLC and is protected by copyright and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Privacy and Data Use</h2>
              <p>
                Your privacy is important to us. Please review our Privacy Policy, which describes how we collect, 
                use, and protect your information. By using our services, you consent to the collection and use of 
                information as described in our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Emergency Services</h2>
              <p>
                Emergency plumbing services are available 24/7. Emergency service calls are subject to additional 
                charges and may require immediate payment. We will make every effort to respond promptly to emergency calls.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Dispute Resolution</h2>
              <p>
                Any disputes arising from these Terms or our services shall be resolved through binding arbitration 
                in accordance with the rules of the American Arbitration Association. The arbitration shall take 
                place in Colorado, and Colorado law shall govern these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Modifications</h2>
              <p>
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon 
                posting to our website. Your continued use of our services after any such changes constitutes 
                acceptance of the new Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Severability</h2>
              <p>
                If any provision of these Terms is found to be unenforceable, the remainder of the Terms shall 
                remain in full force and effect.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Contact Information</h2>
              <div className="bg-blue-50 p-6 rounded-lg">
                <p><strong>Colorado First Plumbing & Sewer LLC</strong></p>
                <p>Licensed Master Plumber</p>
                <p>Email: <a href="mailto:codee@colorado-plumbing.com" className="text-blue-600 hover:underline">codee@colorado-plumbing.com</a></p>
                <p>Phone: </p>
                <p>Website: <a href="https://colorado-plumbing.com" className="text-blue-600 hover:underline">colorado-plumbing.com</a></p>
                <p>Service Area: Denver Metro Area, Colorado</p>
              </div>
              <p className="mt-4">
                For questions about these Terms or our services, please contact us using the information above.
              </p>
            </section>

            <section className="bg-gray-50 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Professional Licensing</h2>
              <p>
                Colorado First Plumbing & Sewer LLC is a licensed plumbing contractor in the state of Colorado. 
                All work is performed by licensed professionals in accordance with local building codes and regulations.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;